import React from "react";
import styled from "@emotion/styled";
import Checkbox from "../UI/Checkbox/Checkbox";

const Container = styled.div`
  margin: 0 0 15px 0;

  display: flex;

  label {
    cursor: pointer;
    font-size: 1rem;
    margin-top: 3px;
  }
`;

const GTCConsent = (props) => {
  return (
    <Container>
      <Checkbox
        checked={props.consent.value}
        id={`${props.consent.name}`}
        onChange={() => {
          props.handleConsentChange({
            target: {
              name: props.consent.name,
              checked: !props.consent.value,
            },
          });
        }}
      />
      <label htmlFor={`${props.consent.name}`}>{props.consent.label}</label>
    </Container>
  );
};

export default GTCConsent;
